// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "/chunks/WistiaEmbed" + "." + "c9b8bce58b1d09a5fc3f" + ".js";
};